import React from 'react'
import { IconArrowRight, IconBolt } from '@tabler/icons-react'

import { Card } from '@/components/cards/Card'
import { Button } from '@/components/buttons/Button'
import { SPINE_LEAD } from './AgenticInsights.constants'
import { Spine } from './Spine'
import { ConversionPanel } from './ConversionPanel'
import {
  getConversionPanelProps,
  getExpectedConversionsPerWeek,
  getOpportunityLabel,
} from './AgenticInsights.helpers'
import { InsightCardMeta } from './InsightCardMeta'
import { DismissInsightButton } from './DismissInsightButton'

// The spotlight card at the top of the Insights (Agent) view: the single
// highest-impact recommendation. Structurally it's the same as InsightSpineCard —
// the goal → obstacle → fix spine plus the Now → Projected conversion panel and
// launch CTA — just given the prominent blue treatment so it reads as "start
// here." The conversion panel + CTA sit on a white slab so those shared pieces
// keep their normal contrast against the blue.
export const HeroInsightCard = ({ insight, onOpen, onDismiss, scopeLabel }) => {
  const extraPerWeek = getExpectedConversionsPerWeek(insight)

  return (
    <Card clickable className="hero-insight-card" onClick={() => onOpen(insight.id)}>
      {onDismiss && <DismissInsightButton insightId={insight.id} onDismiss={onDismiss} />}
      <div className="hero-insight-card__main">
        <div className="hero-insight-card__eyebrow">
          <span className="hero-insight-card__badge">
            <IconBolt className="icon-svg" />
            Top opportunity
          </span>
          {scopeLabel && <span className="hero-insight-card__scope">{scopeLabel}</span>}
          <InsightCardMeta insight={insight} />
        </div>
        <Spine
          nodes={[
            { kind: 'goal', lead: SPINE_LEAD.GOAL, value: getOpportunityLabel(insight) },
            {
              kind: 'obstacle',
              lead: SPINE_LEAD.OBSTACLE,
              value: insight.conversionReason || insight.title,
            },
            {
              kind: 'fix',
              lead: insight.recommendationSummary ? SPINE_LEAD.FIX_SUMMARY : SPINE_LEAD.FIX,
              value: insight.recommendationSummary || insight.recommendation,
              clamp: !insight.recommendationSummary,
            },
          ]}
        />
        {extraPerWeek > 0 && (
          <div className="hero-insight-card__impact">
            Est. <b>+{extraPerWeek.toLocaleString()}</b> more conversions a week if applied
          </div>
        )}
      </div>
      <div className="hero-insight-card__slab">
        <ConversionPanel {...getConversionPanelProps(insight)} />
        <Button
          fullWidth
          className="hero-insight-card__cta"
          icon={<IconArrowRight />}
          alignIcon="right"
          onClick={(event) => {
            event.stopPropagation()
            onOpen(insight.id)
          }}
        >
          Review &amp; launch experiment
        </Button>
      </div>
      <div className="hero-insight-card__polka" />
    </Card>
  )
}
